import React from 'react';
import { useTranslation } from 'react-i18next';
import ExistingPrivacyPolicy from './ExistingPrivacyPolicy';

const PrivacyPolicyView = () => {
    const { t } = useTranslation();

    return (
        <div className="bg-black/20 backdrop-blur-md rounded-2xl p-6 border border-slate-700/50">
            <div className="prose prose-invert max-w-none text-gray-400">
                <ExistingPrivacyPolicy />
            </div>
        </div>
    );
};

export default PrivacyPolicyView;